import { render, staticRenderFns } from "./CaseSummary.vue?vue&type=template&id=5e384450&scoped=true&"
import script from "./CaseSummary.vue?vue&type=script&lang=js&"
export * from "./CaseSummary.vue?vue&type=script&lang=js&"
import style0 from "./CaseSummary.vue?vue&type=style&index=0&id=5e384450&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e384450",
  null
  
)

export default component.exports